import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';

export function TabsHeader() {
  const { t } = useTranslation('settings');

  return (
    <header className="mb-md flex items-center gap-md">
      <Icon type="gear" size="lg" />
      <h1 className="py-sm text-display-sm font-semibold">{t('title')}</h1>
    </header>
  );
}

TabsHeader.displayName = 'TabsHeader';
